import * as React from 'react'

import { cn } from '../../lib/utils'

interface EmptyStateProps {
  icon?: React.ReactNode
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}

function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn('flex flex-col items-center gap-2 px-6 py-14 text-center', className)}
    >
      {icon && <div className="text-fg-subtle [&_svg]:size-5">{icon}</div>}
      <p className="text-fg m-0 text-base font-medium">{title}</p>
      {description && <p className="text-fg-muted m-0 max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  )
}

export { EmptyState, type EmptyStateProps }
